import {
  LandingSection,
  LandingSectionContainer,
  LandingSectionTitle
} from '#/src/custom/components/Landing/LandingSection'
import { VStack, Text, SimpleGrid, GridItem } from '@chakra-ui/react'

const offers = [
  {
    title: 'Fixed.',
    content: [
      'Perfect for tight margins and budgeting certainty.',
      'Ideal for SMEs with steady sales and growing retailers.'
    ]
  },
  {
    title: 'Variable.',
    content: [
      'Aligns expenses with your actual usage.',
      'Perfect for businesses with fluctuating sales or seasonal spikes.'
    ]
  }
]

export const SectionHowMuch = () => {
  return (
    <LandingSection>
      <LandingSectionContainer gap={20}>
        <LandingSectionTitle as="h1">How much does it cost?</LandingSectionTitle>

        <VStack width="full" gap={12}>
          <Text as="h2" fontSize="2xl">
            Our offer models
          </Text>

          <SimpleGrid
            columns={{
              base: 1,
              sm: 2
            }}
            gap={16}>
            {offers.map((offer) => (
              <GridItem
                key={offer.title}
                bg="landing.bg.primary.600"
                color="text.light"
                p={10}
                borderRadius="3xl">
                <VStack alignItems="stretch" gap={10}>
                  <Text
                    as="h3"
                    fontSize={{
                      base: '2xl',
                      md: '3xl'
                    }}>
                    {offer.title}
                  </Text>

                  <VStack
                    alignItems="stretch"
                    gap={8}
                    fontSize={{
                      base: 'lg',
                      md: 'xl'
                    }}>
                    {offer.content.map((content) => (
                      <Text key={content}>{content}</Text>
                    ))}
                  </VStack>
                </VStack>
              </GridItem>
            ))}
          </SimpleGrid>
        </VStack>
      </LandingSectionContainer>
    </LandingSection>
  )
}
